import Leaflet, { LatLng } from 'leaflet';
import { state } from '__common/store';
import {
  arrayDetails,
  popupEvents,
  shouldShowBannersInMiniMap,
} from '__editor/components/roofsSelector/components/roofsSelectorDrawingManager/roofsSelectorPopup';

export function createBingMapPopup(
  roofId: number,
  name: string,
  nrOfModules: number,
  position: LatLng,
  hasPanels: boolean,
  map: Leaflet.Map,
  previewMode: boolean,
) {
  const {projectConfiguration:{projectEnvConfig:{is_aurora_project, is_os_project}}} = state();
  const content = !(is_aurora_project || is_os_project) ? 
  `
  <div class="edit-and-delete-array bing-maps-popup">
    <div class="array-details">
      ${arrayDetails(name, nrOfModules, hasPanels)}
    </div>
    <div class="array-buttons">
      ${shouldShowBannersInMiniMap(roofId, previewMode)}
    </div>
  </div>` :
  `
  <div class="edit-and-delete-array bing-maps-popup">
    <div class="array-details aurora">
      ${arrayDetails(name, nrOfModules, hasPanels)}
    </div>
  </div>`

  const popup = Leaflet.popup({ autoClose: false, closeOnClick: false })
    .setLatLng(position)
    .setContent(content);

  popup.on('add', () => {
    popupEvents();
  });

  return popup;
}


export function createBingMapAzimuth(
  azimuth: number,
  position: LatLng,
) {
  const popup = Leaflet.popup({ autoClose: false, closeOnClick: false, className: 'bing-maps-azimuth-popup' })
    .setLatLng(position)
    .setContent(
    `
      <div class="bing-maps-popup">
        <div class="array-details">
          Azimuth: ${azimuth}\u00B0
        </div>
      </div>
    `,
    );

  popup.on('add', () => {
    popupEvents();
  });

  return popup;
}
